import React from "react";
import { Link } from "react-router-dom";
import { CCol, CContainer, CRow } from "@coreui/react-pro";
import { publicFooterGroups } from "../../config/publicNavigation";

const brandLogoSrc = `${process.env.PUBLIC_URL}/assets/brand/experts4europe-logo.png`;

export default function PublicFooter() {
  return (
    <footer className="public-core-footer">
      <CContainer fluid className="public-core-container">
        <CRow className="g-4 align-items-start public-core-footer__grid">
          <CCol xl={4} lg={4} md={12} className="public-core-footer__brand-col">
            <div className="public-core-footer__brand">
              <img src={brandLogoSrc} alt="Experts4Europe" className="public-core-footer__logo" />
            </div>
          </CCol>
          <CCol xl={8} lg={8} md={12} className="public-core-footer__links-col">
            <div className="public-core-footer__groups">
              {publicFooterGroups.map((group) => (
                <div key={group.title} className="public-core-footer__group-col">
                  <div className="public-core-footer__group">
                    <h3>{group.title}</h3>
                    {group.items.map((item) => (
                      <Link key={item.href} to={item.href}>{item.label}</Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </footer>
  );
}
